<template>
  <div class="style-account">
    <app-bar>My Account</app-bar>
    <div class="style-profile-container my-4">
      <smart-image
        :imageURL="profilePicture"
        class="style-img rounded-circle"
      />
      <div class="fw-bold mb-4">Hello {{ name }}</div>
    </div>
    <row-label-text
      v-for="rowLabel in rowLabels"
      :key="rowLabel.title"
      :title="rowLabel.title"
      :urlLink="rowLabel.urlLink"
    />

    <div class="style-button-container px-1 w-100">
      <default-button
        title="Logout"
        cssClass="scss-button-black"
        @click="handleLogout"
      />
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters
} from "vuex";
import { useToast } from "vue-toastification";
import { paymentGatewayProvider } from "@/common/constant/PaymentTypes";
import { removeToken } from "@/services/jwtService";
import { removeLoginBranch } from "@/services/loginBranch";
import AppBar from "@/components/AppBar.vue";
import DefaultButton from "@/components/button/DefaultButton.vue";
import RowLabelText from "@/components/RowLabelText.vue";
import SmartImage from "@/components/SmartImage.vue";

export default {
  name: "MyAccount",
  components: {
    DefaultButton,
    RowLabelText,
    AppBar,
    SmartImage,
  },
  data() {
    return {
      buttonSettings: {
        title: "Logout",
        cssClass: "scss-button-black",
        clickFn: () => {},
      },
      rowLabels: [],
    };
  },
  computed: {
    name() {
      if (this.loginUserInfo) {
        return this.loginUserInfo.lastName !== null
          ? `${this.loginUserInfo.firstName} ${this.loginUserInfo.lastName}`
          : this.firstName;
      }
      return null;
    },
    isStripe() {
      return this.paymentMethods.some(
        (paymentMethod) =>
          paymentMethod.gateway?.provider === paymentGatewayProvider.STRIPE
      );
    },
    profilePicture() {
      // If user profile image exist
      if (this.loginUserInfo?.image) {
        return this.loginUserInfo?.image;
      }
      return require("@/assets/images/default-user-image.jpg");
    },
    ...mapGetters([
      "init",
      "loginUserInfo",
      "paymentMethods",
    ]),
  },
  methods: {
    async handleLogout() {
      this.showLoading(true);

      await this.getBranches();
      removeToken();
      removeLoginBranch();
      sessionStorage.removeItem("serviceDetails");
      sessionStorage.removeItem("timeslot");
      this.$router.push("/home");

      this.showLoading(false);
      useToast().success("Logout Successfully.");
    },
    ...mapActions(["getBranches", "showLoading"]),
  },
  created() {
    this.rowLabels.push(
        {
          title: "My Profile",
          urlLink: "/account/profile",
        },
        {
          title: "My Booking",
          urlLink: "/account/booking",
        },
    );

    if (this.init.allowCustomerRedemption) {
      this.rowLabels.push({
          title: "My Package",
          urlLink: "/account/package",
      })
    }

    this.rowLabels.push(
      {
        title: "My Salons",
        urlLink: "/account/salon",
      },
      {
        title: "Appointment History",
        urlLink: "/account/appointment",
      },
      {
        title: "My Activities",
        urlLink: "/account/purchase",
      },
    );

    if (this.isStripe) {
      this.rowLabels.push({
        title: "My Cards",
        urlLink: "/account/card",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
span {
  font-size: 17px;
}
.style-img {
  width: 100px;
  height: 100px;
  margin: 25px 0 25px;
  object-fit: cover;
}

.style-account {
  margin-bottom: 130px;
}
.style-profile-container {
  width: 90%;
  margin: 0 auto 0 auto;
  height: fit-content;
  border-radius: 10px;
  overflow: hidden;
  position: relative;
  border: 1px solid #d1d1d1;
  border-right: none;
  border-bottom: none;
  box-shadow: 1px 2px #c3c3c3;
}

.style-plus-icon {
  color: $normal-font-color;
  bottom: 25px;
  right: 0;
  position: absolute;
  border: 1px solid #d1d1d1;
  width: 25px;
  background-color: #ffffff;
  -webkit-text-stroke: 0.5px $normal-font-color;
}

.style-button-container {
  border: 1px solid $border-light-grey;
  position: fixed;
  bottom: 53px;
  max-width: 510px;
}
</style>
